import { useMemo } from "react";
import { Card } from "../_shared";
import { stableKey } from "./format";

export default function SkillsCard({ skills }) {
  const grouped = useMemo(() => {
    const out = {};
    skills.forEach((s) => {
      const cat = s.category || "general";
      (out[cat] ||= []).push(s);
    });
    return out;
  }, [skills]);

  return (
    <Card className="p-5 lg:col-span-2" testid="admin-assessment-skills">
      <h2 className="text-sm font-medium text-slate-900 mb-3">
        Skills{" "}
        <span className="text-slate-400 font-normal">({skills.length})</span>
      </h2>
      {skills.length === 0 ? (
        <p className="text-sm text-slate-500">No skills captured.</p>
      ) : (
        <div className="space-y-3">
          {Object.entries(grouped).map(([cat, list]) => (
            <div key={cat}>
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mb-1">
                {cat}
              </div>
              <div className="flex flex-wrap gap-1.5">
                {list.map((s, idx) => (
                  <span
                    key={stableKey(s, `${cat}-${idx}`)}
                    className="inline-flex items-center rounded-md bg-slate-100 px-2 py-0.5 text-xs text-slate-700"
                    title={
                      s.proficiency
                        ? `Proficiency: ${s.proficiency}${s.years ? ` · ${s.years} yrs` : ""}`
                        : undefined
                    }
                  >
                    {s.name}
                    {s.proficiency && (
                      <span className="ml-1 text-[10px] text-slate-500">
                        · {s.proficiency}
                      </span>
                    )}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
